export const GI_STATUS = {
  PENDING_REVIEW: "PENDING_REVIEW",
  FROZEN: "FROZEN",
  REJECTED: "REJECTED",
};

export const giStatusLabel = (status?: string, hasOpenChange?: boolean): string => {
  if (hasOpenChange) {
    return "Edits pending review";
  }
  if (status === GI_STATUS.PENDING_REVIEW) {
    return "Pending review";
  }
  if (status === GI_STATUS.FROZEN) {
    return "Live";
  }
  if (status === GI_STATUS.REJECTED) {
    return "Changes requested";
  }
  return status || "—";
};

export const giStatusClass = (status?: string, hasOpenChange?: boolean): string => {
  if (hasOpenChange) {
    return "gi-status-chip is-change";
  }
  if (status === GI_STATUS.PENDING_REVIEW) {
    return "gi-status-chip is-pending";
  }
  if (status === GI_STATUS.FROZEN) {
    return "gi-status-chip is-frozen";
  }
  if (status === GI_STATUS.REJECTED) {
    return "gi-status-chip is-rejected";
  }
  return "gi-status-chip";
};
